import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const acuityScheduling = defineConnector({
  identifier: "acuityScheduling",
  name: "Acuity Scheduling",
  tagLine: "Online appointment scheduling",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://acuityscheduling\\.com/api/v1/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.userId,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Acuity Scheduling](https://acuityscheduling.com/), go to **Integrations → API** to find your user ID and API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "User ID",
          required: true,
          target: { kind: "secrets", field: "userId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://acuityscheduling.com/api/v1/me",
  },
});
